/* flow */
import React, { Component } from 'react'
import LegendRow from './LegendRow'
import LegendHeader from './LegendHeader'
import type { Lang } from './App'

export type LegendData = Array<{
  id: string,
  name: string,
  change: ?number,
  valuation: ?number,
  m: ?number,
  y: ?number,
  y3: ?number,
  y5: ?number,
  yMax: ?number,
  color: string,
  bgColor: string,
  sfdrLevel: ?number
}>

type Props = {
  data: LegendData,
  date: string,
  lang : Lang,
  width: number,
  onClick: (id: string) => (event: SyntheticEvent<>) => void,
  mode: Mode
}

class Legend extends Component<Props> {
  render() {
    const { data, date, onClick, lang, width, mode } = this.props
    return (
      <table className="ui selectable striped unstackable compact table ac-legend">
        <LegendHeader
          date={date}
          lang={lang}
          width={width}
          mode={mode}
        />
        <tbody>
        {data.map(item => (
          <LegendRow
            width={width}
            key={item.id}
            {...item}
            onClick={onClick}
            mode={mode}
            lang={lang}
          />
        ))}
        </tbody>
      </table>
    )
  }
}

export default Legend



// WEBPACK FOOTER //
// ./src/Legend.js